// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credential-modal-content {
    background: linear-gradient(135deg, #f4f6fc 0%, #e8ecf8 100%) !important;
}

.credential-modal-content .form-control {
    background: #ffffff !important;
    border: 1px solid rgba(0,0,0,0.06) !important;
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.02) !important;
    color: #1e293b;
}

.credential-modal-content .form-control:focus {
    background: #ffffff !important;
    border-color: var(--text-accent, #6366f1) !important;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2) !important;
}

html[data-theme='dark'] .credential-modal-content {
    background: #1A1F36 !important;
}

html[data-theme='dark'] .credential-modal-content .form-control {
    background: #121625 !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    color: #ffffff;
}

html[data-theme='dark'] .credential-modal-content .form-control:focus {
    background: #0f1322 !important;
    border-color: var(--text-accent, #a5b4fc) !important;
    box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.2) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/dms/ContextCredentialModal.css"],"names":[],"mappings":"AAAA;IACI,wEAAwE;AAC5E;;AAEA;IACI,8BAA8B;IAC9B,6CAA6C;IAC7C,uDAAuD;IACvD,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oDAAoD;IACpD,wDAAwD;AAC5D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oDAAoD;IACpD,yDAAyD;AAC7D","sourcesContent":[".credential-modal-content {\n    background: linear-gradient(135deg, #f4f6fc 0%, #e8ecf8 100%) !important;\n}\n\n.credential-modal-content .form-control {\n    background: #ffffff !important;\n    border: 1px solid rgba(0,0,0,0.06) !important;\n    box-shadow: inset 0 2px 4px rgba(0,0,0,0.02) !important;\n    color: #1e293b;\n}\n\n.credential-modal-content .form-control:focus {\n    background: #ffffff !important;\n    border-color: var(--text-accent, #6366f1) !important;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2) !important;\n}\n\nhtml[data-theme='dark'] .credential-modal-content {\n    background: #1A1F36 !important;\n}\n\nhtml[data-theme='dark'] .credential-modal-content .form-control {\n    background: #121625 !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    color: #ffffff;\n}\n\nhtml[data-theme='dark'] .credential-modal-content .form-control:focus {\n    background: #0f1322 !important;\n    border-color: var(--text-accent, #a5b4fc) !important;\n    box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.2) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
